import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import { Country, State, City } from "country-state-city";
import { FaWhatsapp } from "react-icons/fa";

import {
  OverlayTrigger,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class Warehouse extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawmaterialwarehouse: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
    };
    this.inputFile = React.createRef();
  }

  // ---------- API Calls ----------
  GetRawMaterialWarehouses = () => {
    fetch(
      process.env.REACT_APP_API +
        "Warehouse/GetRawMaterialWarehouses/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status !== 400) {
          this.setState({ rawmaterialwarehouse: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  // ---------- CSV DOWNLOAD ----------
  DownloadWarehousesToCSV = () => {
    fetch(
      `${process.env.REACT_APP_API}Warehouse/DownloadRawMaterialWarehousesToCSV/${this.context.storeId}`,
      { method: "GET" }
    )
      .then((response) => {
        if (!response.ok) throw new Error("Download failed");
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const now = new Date();
        a.download = `warehouses-${now.getFullYear()}${String(
          now.getMonth() + 1
        ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}-${String(
          now.getHours()
        ).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(
          now.getSeconds()
        ).padStart(2, "0")}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("DownloadWarehousesToCSV error", error);
        this.ShowMessagBox("Error", "Download failed");
      });
  };

  // ---------- CSV UPLOAD ----------
  onUploadButtonClick = () => this.inputFile.current?.click();

  handleFileUpload = (e) => {
    const { files } = e.target;
    if (!files || !files[0]) return;
    const reader = new FileReader();
    reader.onload = (ev) => this.UploadWarehousesFromCSV(ev.target.result);
    reader.readAsText(files[0]);
  };

  UploadWarehousesFromCSV = (csvstr) => {
    fetch(
      `${process.env.REACT_APP_API}Warehouse/UploadRawMaterialWarehousesFromCsv/${this.context.storeId}`,
      {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: csvstr,
      }
    )
      .then((response) => {
        if (!response.ok) throw new Error("Upload failed");
        return response.text();
      })
      .then((data) => {
        this.ShowMessagBox("Information", "Warehouses uploaded successfully!");
        this.GetRawMaterialWarehouses();
      })
      .catch((error) => {
        console.error("UploadWarehousesFromCSV error", error);
        this.ShowMessagBox("Error", "Upload failed - invalid CSV");
      });
  };

  // ---------- Helpers ----------
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };
  OnSaved = () => this.OnRefreshButtonClick();
  OnDeleted = () => this.OnRefreshButtonClick();
  OnRefreshButtonClick = () => {
    this.setState({ rawmaterialwarehouse: [] }, () =>
      this.GetRawMaterialWarehouses()
    );
  };
  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };
  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.rawmaterialwarehouse.length === 0)
      this.GetRawMaterialWarehouses();
    document.addEventListener("keydown", (event) => {
      if (event.key === "F8") {
        this.setState({ addModalShow: true });
      } else if (event.key === "F9") {
        this.OnRefreshButtonClick();
      }
    });
  };

  render() {
    return (
      <>
        <div className="m-0 p-0">
          <input
            style={{ display: "none" }}
            type="file"
            accept=".csv"
            ref={this.inputFile}
            onChange={this.handleFileUpload}
          />
          <Row className="m-0 p-0 border-0 border-dark">
            <Col xs={12} className=" m-0 p-0">
              {this.state.msgboxOpen && (
                <MessageBox
                  open={this.state.msgboxOpen}
                  title={this.state.msgboxTitle}
                  message={this.state.msgboxMessage}
                  callback={this.CloseMessagBoxCallback}
                />
              )}
              <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
                <h4>
                  {" "}
                  <b>&nbsp;Warehouses / Plants &nbsp;</b>
                </h4>
                <Navbar.Collapse className="justify-content-end mx-2">
                  <Nav>
                    <ButtonToolbar className="text-end align-middle">
                      <Button
                        size="sm"
                        className="mainthemecolor"
                        onClick={() => this.setState({ addModalShow: true })}
                        disabled={
                          this.state.rawmaterialwarehouse.length >=
                            this.context.storeSettings.totalWarehouses ?? 1
                        }
                      >
                        + Add (F8)
                      </Button>
                      &nbsp;
                      <Button
                        className="mainthemecolor"
                        size="sm"
                        onClick={() => this.OnRefreshButtonClick()}
                      >
                        <BiRefresh size="16" />
                        &nbsp;Refresh (F9)
                      </Button>
                      &nbsp;
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={this.DownloadWarehousesToCSV}
                      >
                        Download CSV
                      </Button>
                      &nbsp;
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={this.onUploadButtonClick}
                      >
                        Upload CSV
                      </Button>
                      &nbsp;
                      {this.state.addModalShow && (
                        <RawMaterialWarehouseAddOrEditModal
                          show={this.state.addModalShow}
                          Type="Add"
                          onHide={this.addModalClose}
                        />
                      )}
                    </ButtonToolbar>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
              <div className="purposestyle">
                <h6>
                  <b>Purpose:</b> Manage all Warehouses/Plants where
                  Rawmaterials / products are stocked.
                </h6>
              </div>
              <div className="p-1">
                <Table hover border striped className="px-0 bg-white p-3">
                  <thead>
                    <tr className="text-start text-black bg-white border">
                      <th width="5%"></th>
                      <th width="25%">Name</th>
                      <th width="20%">Address</th>
                      <th width="10%">MobileNo</th>
                      <th width="20%">Email-Id</th>
                      <th width="10%">City</th>
                      <th width="10%" className="text-end">
                        Options
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-primary border">
                    {this.state.rawmaterialwarehouse
                      .sort((a, b) =>
                        a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1
                      )
                      .map((rawmaterialwarehouse, i) =>
                        this.state.reload ? (
                          <EditRawMaterialWarehouseInline
                            key={i}
                            index={i}
                            rawmaterialwarehouse={rawmaterialwarehouse}
                            OnDeleted={this.OnDeleted}
                            Refresh={this.addModalClose}
                          />
                        ) : null
                      )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

// Keep your EditRawMaterialWarehouseInline and RawMaterialWarehouseAddOrEditModal unchanged
// (no CSV logic needed there)

export class EditRawMaterialWarehouseInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawmaterialwarehouse: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.rawmaterialwarehouse.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "Warehouse/DeleteRawMaterialWarehouse/" +
        this.state.rawmaterialwarehouse.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This RawMaterialWarehouse may be associated with few Products. First disassociate this rawmaterialwarehouse from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({ rawmaterialwarehouse: this.props.rawmaterialwarehouse });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
    this.props.Refresh();
  };
  sanitizePhoneNumber(phone) {
    if (!phone) return "";
    const digits = String(phone).replace(/\D/g, "");
    // remove any leading zeros
    return digits.replace(/^0+/, "");
  }

  // return string suitable for wa.me (prefix with country code when needed)
  getWhatsAppNumber(phone) {
    const digits = this.sanitizePhoneNumber(phone);
    if (!digits) return null;

    // If digits already look like they include country code (length > 10), return as-is
    if (digits.length > 10) return digits;

    // if 10 digits, prepend country code - use store countryCode if present, fallback to 91
    const cc = (this.context?.store?.countryCode || "91")
      .toString()
      .replace(/\D/g, "");
    return `${cc}${digits}`;
  }

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <RawMaterialWarehouseAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            rawmaterialwarehouse={this.state.rawmaterialwarehouse}
            Type="Edit"
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <tr
          className="text-start align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
          onClick={(e) => {
            this.OnEditButtonClick(e);
          }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td>{this.props.index + 1}</td>
          <td className="text-start ">
            {this.state.rawmaterialwarehouse.name}
          </td>
          <td className="text-start ">
            {this.state.rawmaterialwarehouse.address +
              ", " +
              this.state.rawmaterialwarehouse.city +
              ", " +
              this.state.rawmaterialwarehouse.state +
              ", " +
              this.state.rawmaterialwarehouse.country}
          </td>

          <td className="text-start" style={{ whiteSpace: "nowrap" }}>
            {this.state.rawmaterialwarehouse.contactNo || "—"}

            {/* whatsapp link */}
            {(() => {
              const waNum = this.getWhatsAppNumber(
                this.state.rawmaterialwarehouse.contactNo
              );
              if (!waNum) return null;
              const waUrl = `https://wa.me/${waNum}`;

              return (
                <OverlayTrigger overlay={<Tooltip>Open WhatsApp</Tooltip>}>
                  <a
                    href={waUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ms-2"
                    style={{ textDecoration: "none" }}
                    title={`WhatsApp ${this.state.rawmaterialwarehouse.contactNo}`}
                  >
                    <FaWhatsapp
                      size={18}
                      style={{ color: "#25D366", verticalAlign: "middle" }}
                    />
                  </a>
                </OverlayTrigger>
              );
            })()}
          </td>
          <td className="text-start ">
            {this.state.rawmaterialwarehouse.emailId}
          </td>
          <td className="text-start ">
            {this.state.rawmaterialwarehouse.city}
          </td>

          <td className="col-md-2 text-end align-middle ">
            <div class="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  className=" rounded-circle"
                  variant="warning"
                  size="sm"
                  onClick={(e) => {
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="16" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip>Warning! This will delete all dependents.</Tooltip>
                }
              >
                <Button
                  className="mx-1  rounded-circle"
                  size="sm"
                  variant="danger"
                  disabled={
                    this.context.UserRoles.PRODUCTADMIN !=
                    this.context.userData.roleId
                  }
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "Warning! This action will delete all it dependents. Are you sure you want to Delete?"
                      )
                    ) {
                      this.OnDelete(e);
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class RawMaterialWarehouseAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      rawmaterialwarehouse: {
        name: "",
        address: "",
        emailId: "",
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateRawMaterialWarehouseInDB = () => {
    this.ShowLoadSpinner();

    var tmpRawMaterialWarehouse = this.state.rawmaterialwarehouse;
    if (this.props.Type == "Edit") {
      tmpRawMaterialWarehouse = this.props.rawmaterialwarehouse;
    } else {
      tmpRawMaterialWarehouse.storeId = this.context.storeId;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpRawMaterialWarehouse),
    };

    fetch(
      process.env.REACT_APP_API + "Warehouse/AddOrUpdateRawMaterialWarehouse/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This RawMaterialWarehouse is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateRawMaterialWarehouseInDB();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "name":
        this.state.rawmaterialwarehouse.name = value;
        break;
      case "address":
        this.state.rawmaterialwarehouse.address = value;
        break;
      case "city":
        this.state.rawmaterialwarehouse.city = value;
        break;
      case "state":
        this.state.rawmaterialwarehouse.state = value;
        break;
      case "country":
        this.state.rawmaterialwarehouse.country = value;
        break;
      case "contactNo":
        if (Number.isInteger(Number(value)))
          this.state.rawmaterialwarehouse.contactNo = value;
        break;
      case "emailId":
        this.state.rawmaterialwarehouse.emailId = value;
        break;
    }
    this.setState({ rawmaterialwarehouse: this.state.rawmaterialwarehouse });
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({ rawmaterialwarehouse: this.props.rawmaterialwarehouse });
    }
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="RawMaterialWarehouseModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit" ? "Edit Warehouse" : "Add Warehouse"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Warehouse Name *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="name"
                        maxlength="49"
                        focus
                        autoFocus
                        value={this.state.rawmaterialwarehouse.name}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Address
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="address"
                        maxlength="254"
                        value={this.state.rawmaterialwarehouse.address}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      City *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="city"
                        maxlength="49"
                        required
                        value={this.state.rawmaterialwarehouse.city}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Country *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="country"
                        value={this.state.rawmaterialwarehouse.country}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {Country.getAllCountries().map((country) => (
                          <>
                            <option value={country.isoCode}>
                              {country.name}
                            </option>
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      State *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="state"
                        value={this.state.rawmaterialwarehouse.state}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {State.getStatesOfCountry(
                          this.state.rawmaterialwarehouse.country
                        ).map((s1) => (
                          <>
                            <option>{s1.name}</option>
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Contact No *
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="contactNo"
                        maxlength={10}
                        required
                        value={this.state.rawmaterialwarehouse.contactNo}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">
                      Email Id
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="email"
                        name="emailId"
                        maxlength="99"
                        value={this.state.rawmaterialwarehouse.emailId}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
